import React, { useEffect, useState } from 'react';

import { useChanges } from "../../../hooks/useChanges";
import { useAdvanceChanges } from "../../../hooks/useAdvanceChanges";
import './Slider.scss'; // Підключіть ваш CSS файл

const CustomSliderRange25 = ({ currentAction, setCurrentAction, item, color, data, keyName, advance }) => {
    const { addChangeToStore } = useChanges();
    const { addAdvanceChangeToStore } = useAdvanceChanges();
    const [value, setValue] = useState(data && data[keyName] ? data[keyName] : 50);
    const [classNameBg, setClassNameBg]= useState('')

    const handleChange = (event) => {
        const newValue = event.target.value;
        setValue(newValue);
        if (advance) {
            addAdvanceChangeToStore({ key: keyName, value: newValue });
            return;
        }
    addChangeToStore({ key: keyName, value: newValue });
    };


    useEffect(() => {
        if(currentAction === 'Kick'){
            setClassNameBg('kick')
        } else if (currentAction === 'Log'){
            setClassNameBg('log')
        } else if (currentAction === 'Ban'){
            setClassNameBg('ban')
        } else if (currentAction === 'Revoke Roles'){
            setClassNameBg('revoke_roles')
        } else if (currentAction === 'Warn'){
            setClassNameBg('warn')
        } else {
            setClassNameBg(color)
        }
    },[currentAction])

    const displayValue = Math.round(value / 100 * 25);


    return (
        <div className="slider-container">
            <div className='slider_container_end-point'>
                <p className='slider_container_end-point_left'>1</p>
                <p className='slider_container_end-point_right'>25</p>
            </div>
            <div style={{left:`${value-4}%`}} className='slider_container_value_img'>
                <img src="/img/ValuesBg.svg" alt="" />
                <p className='slider_container_value'>{displayValue}</p>
            </div>
            <div className='input_slider_wrap'>
                <div className='custom_slider_bg'></div>
                <input
                    type="range"
                    min="0"
                    max="100"
                    value={value}
                    className="slider"
                    onChange={handleChange}
                />
                <div style={{width:`${value}%` }} className={`custom_slider_bg_active choose_action_item_${classNameBg}`}></div>
            </div>
            <div className='input_slider_point'>
                <div className={`input_slider_point_item ${ value >= 0 ? `choose_action_item_${classNameBg}` : ''}  `}></div>
                <div className={`input_slider_point_item ${ value >= 20 ? `choose_action_item_${classNameBg}` : ''}  `}></div>
                <div className={`input_slider_point_item ${ value >= 50 ? `choose_action_item_${classNameBg}` : ''}  `}></div>
                <div className={`input_slider_point_item ${ value >= 70 ? `choose_action_item_${classNameBg}` : ''}  `}></div>
                <div className={`input_slider_point_item ${ value >= 100 ? `choose_action_item_${classNameBg}` : ''}  `}></div>
            </div>
            {/* Тут можна додати додаткові мітки або елементи */}
        </div>
    );
};

export default CustomSliderRange25;